import authenticationApi from '../api/authenticationApi';
import localStorageProvider from '../utils/localStorageProvider';
import routePaths from '../routePaths';
import { actions as notificationActions } from './notificationActions';
import * as logger from '../utils/logger';
import Sentry from '../sentry';
import history from '../history';
import config from '../config';
import { failure, success } from './helpers';
import { handleNestedErrors } from '../utils/validation';
import { parseValidationErrors } from './backedValidationErrorsParser';

export const types = {
  SIGN_IN: 'SIGN_IN',
  SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
  SIGN_IN_FAILURE: 'SIGN_IN_FAILURE',
  SIGNED_OUT: 'SIGNED_OUT',
  CURRENT_USER_DATA: 'CURRENT_USER_DATA',
  CURRENT_USER_DATA_SUCCESS: 'CURRENT_USER_DATA_SUCCESS',
  CURRENT_USER_DATA_FAILURE: 'CURRENT_USER_DATA_FAILURE',
  ACCOUNT_ACTIVATION_SUBMIT: 'ACCOUNT_ACTIVATION_SUBMIT',
  ACCOUNT_ACTIVATION_SUCCESS: 'ACCOUNT_ACTIVATION_SUCCESS',
  ACCOUNT_ACTIVATION_FAILURE: 'ACCOUNT_ACTIVATION_FAILURE',
};

const authFailureReasons = Object.freeze({
  tokenExpired: 'tokenExpired',
});

export const actions = {
  signIn: (signInData, returnTo) => dispatch => {
    dispatch({ type: types.SIGN_IN });

    return authenticationApi
      .signIn(signInData)
      .then(authenticationResult => {
        if (authenticationResult.ok) {
          localStorageProvider.setItem(config.AUTH_STATE_ITEM_NAME, true);
          dispatch({ type: types.SIGN_IN_SUCCESS });
          dispatch(actions.getCurrentUserData());
          return history.push(returnTo || routePaths.home);
        }

        dispatch({type: types.SIGN_IN_FAILURE});
        dispatch(notificationActions.showError('Logowanie nie powiodło się'));
        return logger.error(authenticationResult);
      });
  },
  register: (data) => dispatch => {
    return authenticationApi
      .register(data)
      .then(authenticationResult => {
        if (authenticationResult.ok) {
          dispatch(notificationActions.showSuccess('Konto zostało zarejestrowane'));
          return success();
        }

        dispatch(notificationActions.showError('Rejestracja nie powiodła się'));
        logger.error(authenticationResult);
        return failure(handleNestedErrors(parseValidationErrors(authenticationResult.data.validationErrors)));
      });
  },
  signOut: (returnTo) => dispatch => {
    localStorageProvider.removeItem(config.AUTH_STATE_ITEM_NAME);
    Sentry.setUser(null);

    return authenticationApi
      .signOut()
      .then(result => {
        if (result.ok) {
          dispatch({ type: types.SIGNED_OUT });
          history.push(returnTo ? `${routePaths.signIn}?returnTo=${returnTo}` : routePaths.signIn);
        }
      });
  },
  activateAccount: activateAccountData => dispatch => {
    dispatch({ type: types.ACCOUNT_ACTIVATION_SUBMIT });

    return authenticationApi
      .activateAccount(activateAccountData)
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.ACCOUNT_ACTIVATION_SUCCESS });
          dispatch(notificationActions.showSuccess('Konto zostało aktywowane'));
          return history.push(routePaths.signIn);
        }

        if (response.status === 401 && response.data.failureReason === authFailureReasons.tokenExpired) {
          dispatch({ type: types.ACCOUNT_ACTIVATION_FAILURE });
          return dispatch(notificationActions.showError('Link aktywacyjny utracił ważność'));
        }

        dispatch({ type: types.ACCOUNT_ACTIVATION_FAILURE });
        dispatch(notificationActions.showError('Nie udało się aktywować konta'));
        return logger.error(response);
      });
  },
  recoverPassword: recoverPasswordData => dispatch => {
    return authenticationApi
      .recoverPassword(recoverPasswordData)
      .then(response => {
        if (response.ok) {
          dispatch(notificationActions.showSuccess('Link do resetu hasła został wysłany'));
          return history.push(routePaths.signIn);
        } else {
          dispatch(notificationActions.showError('Nie udało się odzyskać hasła'));
          return logger.error(response);
        }
      });
  },
  resetPassword: resetPasswordData => dispatch => {
    return authenticationApi
      .resetPassword(resetPasswordData)
      .then(response => {
        if (response.ok) {
          dispatch(notificationActions.showSuccess('Hasło zostało zaktualizowane'));
          return history.push(routePaths.signIn);
        }

        if (response.status === 401 && response.data.failureReason === authFailureReasons.tokenExpired) {
          return dispatch(notificationActions.showError('Link do resetu hasła utracił ważność'));
        }

        dispatch(notificationActions.showError('Nie udało się ustalić hasła'));
        return logger.error(response);
      });
  },
  getCurrentUserData: () => dispatch => {
    dispatch({ type: types.CURRENT_USER_DATA });
    return authenticationApi
      .me()
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.CURRENT_USER_DATA_SUCCESS, data: response.data });
          Sentry.setUser({ id: response.data.id });
        } else {
          dispatch({ type: types.CURRENT_USER_DATA_FAILURE });
        }
      });
  },
  wkSignIn: () => () => {
    return authenticationApi
      .wkSignIn()
      .then(authenticationResult => {
        if (authenticationResult.ok) {
          const form = document.createElement("form");
          form.method = "POST";
          form.action = authenticationResult.data.destination;
          form.enctype = "application/x-www-form-urlencoded";

          const element1 = document.createElement("input"); 
          element1.type = "hidden";
          element1.name = "SAMLRequest";
          element1.value = authenticationResult.data.samlRequest;
          form.appendChild(element1);

          document.body.appendChild(form);
          form.submit();
          return;
        }

        return logger.error(authenticationResult);
      });
  },
};



// WEBPACK FOOTER //
// ./src/actions/authActions.js